import { Component, Input } from '@angular/core';
@Component({
  selector: 'payarc-card',
  template: `<div class="pa-card" [class.pa-card--hero]="hero"><ng-content></ng-content></div>`,
  styleUrls: ['./payarc-card.component.css'],
  standalone: false
})
export class PayarcCardComponent {
  /** hero = elevated + signature asymmetric corner (use sparingly) */
  @Input() hero = false;
}
